import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
var PaginationShowcase = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment pagination on ShowCasePagination {\n    cursor\n    next\n    previous\n  }\n"])));
export default PaginationShowcase;